import cx from 'classnames';

import { PARTNER_LOGOS } from '../config/catalogConfig';
import { ServicePartner } from '../types';

interface PartnerLogoProps {
  partner: ServicePartner;
  size?: 'small' | 'default' | 'large';
  className?: string;
}

/** Monogram z názvu („Výtahy Vaněrka" → „VV"), když partner ještě nemá dodané logo. */
const monogram = (name: string): string =>
  name
    .replace(/[^\p{L}\p{N} ]/gu, ' ')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ partner, size = 'default', className }) => {
  const logo = PARTNER_LOGOS[partner.slug];

  if (logo) {
    return (
      <div className={cx('PartnerLogo', `PartnerLogo--${size}`, 'PartnerLogo--image', className)}>
        <img src={logo} alt={partner.name} />
      </div>
    );
  }

  return (
    <div className={cx('PartnerLogo', `PartnerLogo--${size}`, 'PartnerLogo--monogram', className)} aria-label={partner.name}>
      <span>{monogram(partner.name)}</span>
    </div>
  );
};

export default PartnerLogo;
